const ITEMS = [
  "IDRAULICA RAPIDA",
  "SCATTO IN SCOOTER",
  "NESSUN COSTO NASCOSTO",
  "ZERO CONTANTE",
  "B&B CHECK-IN SALVATI",
  "INTERVENTO CERTIFICATO",
  "CHIAIA",
  "VOMERO",
  "CENTRO STORICO",
  "POSILLIPO",
  "TOLEDO",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      className="overflow-hidden border-y border-white/10 bg-[#060B19] py-5"
      data-testid="editorial-marquee-strip"
    >
      <div className="animate-marquee flex w-max items-center gap-8 whitespace-nowrap">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-8">
            <span className="font-display text-2xl font-black uppercase tracking-wide text-outline">
              {item}
            </span>
            <span className="h-2 w-2 rotate-45 bg-[#FF5500]" />
          </span>
        ))}
      </div>
    </div>
  );
}
